import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	computed,
	inject,
	input,
	output,
} from '@angular/core';

import { ICMMSLocation } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { FormControl, Validators } from '@angular/forms';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { AuExpandableTagsModule } from '@shared/ui-components';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { AuLocationsTreeSelectorComponent } from '@shared/ui-components/au-locations-tree-selector/au-locations-tree-selector.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { TranslateService } from '@tolgee/ngx';
import { LocationAncestryService } from '@app/shared/services/location-ancestry.service.component';

@Component({
	selector: 'cmms-locations-section',
	imports: [
		MatMenuModule,
		AuExpandableTagsModule,
		MatTooltipModule,
		MatButtonModule,
		MatRippleModule,
		MatIconModule,
		AuLocationsTreeSelectorComponent,
		NgxTolgeeModule,
	],
	templateUrl: './cmms-locations-section.component.html',
	styleUrls: ['./cmms-locations-section.component.scss'],
})
export class CmmsLocationsSectionComponent implements OnInit {
	private readonly locationAncestryService = inject(LocationAncestryService);
	private readonly translateService = inject(TranslateService);

	locationsInputList = input<Partial<ICMMSLocation>[]>([]);
	@Input()
	set isRequired(value: boolean) {
		if (value) {
			this.formControl.setValidators([Validators.required]);
		}
	}
	@Input() disableMultipleSelect = false;
	@Input() matTooltipText = this.translateService.instant('edit_locations');
	@Input() editable = true;
	@Input() showAmount = 5;
	disableNestedSelection = input<boolean>(false);
	protected allowDeselectForSingleSelect = input(true);
	locationsChanged = output<Partial<ICMMSLocation>[]>();
	@Output()
	controlReady = new EventEmitter<FormControl<Partial<ICMMSLocation>[]>>();
	@ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

	displayedLocations = computed(
		() =>
			this.locationsInputList()?.map(location =>
				this.locationAncestryService.replaceName(location as ICMMSLocation)
			) || []
	);

	formControl = new FormControl<Partial<ICMMSLocation>[] | null>(null);

	ngOnInit() {
		this.controlReady.emit(this.formControl);
	}

	openLocationsList($event: MouseEvent) {
		$event.preventDefault();
		this.menuTrigger.openMenu();
	}

	treeViewStateChanged($event: Partial<ICMMSLocation>[]) {
		this.locationsChanged.emit($event);

		this.formControl.setValue($event, {
			emitEvent: false,
		});

		if (this.disableMultipleSelect) {
			this.menuTrigger.closeMenu();
		}
	}

	get isRequired() {
		return this.formControl.hasValidator(Validators.required);
	}

	get isRequiredAndInvalid(): boolean {
		return (
			this.isRequired && this.formControl.touched && this.formControl.hasError('required')
		);
	}
}
